import UIFlex from 'UIComponents/layout/UIFlex';
import { SkeletonBlock, SkeletonWrapper } from '../../../Skeleton';
import ReducedSkeletonThumbnail from './ReducedSkeletonThumbnail';
import { OBSIDIAN, PANTERA } from 'HubStyleTokens/colors';
import { REDUCED_CARD_THUMBNAIL_SIZES } from '../ReducedCardTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReducedCardSkeleton = ({
  use,
  size = 'small'
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    "data-test-id": "skeleton",
    children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
      shimmercolor: use === 'on-dark' ? OBSIDIAN : undefined,
      style: {
        borderRadius: 3,
        height: REDUCED_CARD_THUMBNAIL_SIZES[size]
      },
      children: /*#__PURE__*/_jsx(ReducedSkeletonThumbnail, {
        backgroundColor: use === 'on-dark' ? PANTERA : undefined,
        size: size
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "m-left-4",
      children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
        shimmercolor: use === 'on-dark' ? OBSIDIAN : undefined,
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          color: use === 'on-dark' ? PANTERA : undefined,
          style: {
            height: 16,
            width: 230
          }
        })
      }), /*#__PURE__*/_jsx(SkeletonWrapper, {
        className: "m-top-3",
        shimmercolor: use === 'on-dark' ? OBSIDIAN : undefined,
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          color: use === 'on-dark' ? PANTERA : undefined,
          style: {
            height: 14,
            width: 180
          }
        })
      })]
    })]
  });
};
export default ReducedCardSkeleton;